module.exports = __webpack_public_path__ + "media/pdfs/exterior_terms-fd15853c472c6ae705c2c8637c230ff9.pdf";